var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('chip',{style:(_vm.chipStyle),attrs:{"color":_vm.profilePhoto.color}},[(_vm.profilePhoto.image)?_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.profilePhoto.image,"alt":`Profile photo for ${_vm.profilePhoto.fullName}`}}):_c('span',[_vm._v(_vm._s(_vm.profilePhoto.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }